import script from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTab.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTab.vue?vue&type=style&index=0&id=179ba737&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-179ba737"]])

export default __exports__